export const locales = ["pt-br", "en-us", "ru-ru", "uk-ua", "es-es"];
